import { useState, useEffect, useCallback } from 'react'
import { getSearchableManageMembers, ManageMemberFilters } from '../../services/manageMemberService'
import { ManageMemberModel } from '../../pages/manageMembers/models/ManageMemberModel'

export const useSearchableManageMembers = (
  search: string,
  activeTab: string,
  limit: number,
  offset: number,
  filters: ManageMemberFilters = {}
) => {
  const [data, setData] = useState<ManageMemberModel | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)
  const [refreshKey, setRefreshKey] = useState(0)

  const refetch = useCallback(() => {
    setRefreshKey(prev => prev + 1)
  }, [])

  useEffect(() => {
    let isMounted = true

    const fetch = async () => {
      try {
        setLoading(true)
        const data = await getSearchableManageMembers(
          search ?? '',
          activeTab,
          limit,
          offset,
          filters
        )

        if (isMounted) {
          setData(data)
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetch()

    return () => {
      isMounted = false
    }
    // Serialize filters so the effect re-runs on value changes, not object identity.
  }, [search, activeTab, offset, refreshKey, filters.plan, filters.isActive]) // <- importante

  return { data, loading, error, refetch }
}